import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {apiClient} from 'common/util/api-client';
import {getProjectId} from 'common/report/util';
import {getLocation} from 'common/util/url';
import {ProjectTeam} from 'common/types/app-api/project-team';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint() {
  return appApiUrl(`granted-teams`, {projectId: getProjectId()});
}

async function fetchProjectTeams(fromFetchCache: boolean): Promise<{[key: string]: ProjectTeam}> {
  // eslint-disable-next-line local-rules/deprecated-member-access
  const result = await apiClient.fetch(buildEndpoint(), {
    headers: {
      'Request-URL': getLocation().href,
    },
    method: `GET`,
    fromFetchCache,
  });
  const projectTeams: ProjectTeam[] = (await result?.json())?.results?.teams ?? [];
  // If this is from cache, and it's empty, return null instead of an empty set.
  // Otherwise, ApiResource will signal that the index fetch is done, when it really isn't
  if (!projectTeams.length && fromFetchCache) {
    return null as any;
  }
  const initialValue: {[key: string]: ProjectTeam} = {};
  return projectTeams.reduce((acc, teamItem) => {
    acc[teamItem.id.toString()] = teamItem;
    return acc;
  }, initialValue);
}

export const projectTeamsClient: ApiResourceClient<ProjectTeam> = {
  index() {
    return {
      cache: fetchProjectTeams(true),
      network: fetchProjectTeams(false),
    };
  },

  get() {
    throw new Error(`Getting a single project team is not supported`);
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
